import { useEffect, useRef, memo } from 'react';

// Overview widget – shows a chart with multiple commodities, live prices
function TradingViewOverview() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.innerHTML = '<div class="tradingview-widget-container__widget"></div>';
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: 'dark',
      dateRange: '12M',
      showChart: true,
      locale: 'fr',
      largeChartUrl: '',
      isTransparent: true,
      showSymbolLogo: true,
      showFloatingTooltip: true,
      width: '100%',
      height: '520',
      plotLineColorGrowing: 'rgba(255, 208, 40, 1)',
      plotLineColorFalling: 'rgba(255, 100, 100, 1)',
      gridLineColor: 'rgba(255, 255, 255, 0.06)',
      scaleFontColor: 'rgba(255, 255, 255, 0.6)',
      belowLineFillColorGrowing: 'rgba(255, 208, 40, 0.12)',
      belowLineFillColorFalling: 'rgba(255, 100, 100, 0.12)',
      symbolActiveColor: 'rgba(255, 208, 40, 0.16)',
      tabs: [
        {
          title: 'Matières premières',
          symbols: [
            { s: 'OANDA:XCUUSD', d: 'Cuivre' },
            { s: 'OANDA:XAUUSD', d: 'Or' },
            { s: 'OANDA:XAGUSD', d: 'Argent' },
            { s: 'TVC:USOIL', d: 'Pétrole WTI (bitume)' },
            { s: 'OANDA:XPTUSD', d: 'Platine' },
            { s: 'OANDA:XPDUSD', d: 'Palladium' },
          ],
        },
      ],
    });
    containerRef.current.appendChild(script);
  }, []);

  return (
    <div className="tradingview-widget-container" ref={containerRef}>
      <div className="tradingview-widget-container__widget" />
    </div>
  );
}

export default memo(TradingViewOverview);
